import PropTypes from "prop-types";

import PersonPresenter from "presenters/PersonPresenter";
import FacePresenter from "presenters/FacePresenter";
import DisplayPerson from "components/DisplayPerson";

import FaceContainer from "../FaceContainer";

const PeopleList = ({ people, faceSelected, setFaceSelected }) => {
  return people?.map((person) => (
    <FaceContainer key={person.id}>
      <DisplayPerson
        showLabel
        showCheck
        faceSelected={faceSelected}
        person={person}
        onCheck={(faceChecked) => setFaceSelected(faceChecked)}
      />
    </FaceContainer>
  ));
};

PeopleList.propTypes = {
  people: PropTypes.arrayOf(PersonPresenter.shape()),
  faceSelected: PropTypes.oneOfType([PersonPresenter.shape(), FacePresenter.shape()]),
  setFaceSelected: PropTypes.func.isRequired,
};

export default PeopleList;
